import React from 'react'
import { Row, Container } from 'react-bootstrap';
import './casestudybody34.css';

import clientimg from '../images/case-study-client34.webp'
import outcome from '../images/outcome34.webp'

import sm1 from '../images/cs34so1.webp'
import sm2 from '../images/cs34so2.webp'
import sm3 from '../images/cs34so3.webp'
import sm4 from '../images/cs34so4.webp'


const Casestudybody34 = () => {

    return (
        <>
          <section className='casestudybody34-section'  >
          <Container>

            <Row className='w-100 py-md-5 py-4 clintrow'>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <h2>About</h2>
                      {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                      <div className="h1">The Client</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>A Master Developer offering development management services across real estate segment. The company's current portfolio includes 2 development funds and 2 investment funds of $400 Mn</p>
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={clientimg} alt="" />
                </div>
            </Row>
       
            <Row className='mt-md-5'>
              <div className='col-md-12'>
                <div className='content-box'>
                  <h2>Situation</h2>
                  {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                  <div className="h1">Overview</div>
                  <p className='anima '><span className='only-anima-underline' > **** </span></p>
                  <p>The client wanted to develop a Master Developer Partnership Proposal to present to a prominent landowner, aiming to be appointed as the Master Developer for $200 Mn fund</p>
                </div>
                
              </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody34-section bg-gredient-dark'>
        <Container>
            <Row>
              <div className='col-md-12'>
                  <div className='content-box'>
                    <h2>Approach &</h2>
                    {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                    <div className="h1">Methodology:</div>
                    <p className='anima '><span className='only-anima-underline' > **** </span></p>
                    <div className='text'>
                            {/* <p>Our team employed a structured and detailed process to meet the client's specific requirements:</p> */}
                        </div>
                    
                    <div><span className='method-stage'>Location and Site Assessment</span></div>
                
                    <div className='list-text my-3'>
                        <div className='icon'>
                        
                        </div>
                        <div className='text'>
                            <p>Conducted a detailed <span style={{color:"#03A393"}}>analysis of the site's accessibility, proximity,</span> and other factors that contribute to creating favorable investment opportunities within the city </p>
                        </div>
                      </div>


                      <div><span className='method-stage'>Comprehensive Financial Assessment</span></div>
                
                    <div className='list-text my-3'>
                        <div className='icon'>
                        
                        </div>
                        <div className='text'>
                            <p>Developed a robust feasibility model that <span style={{color:"#03A393"}}>forecasts 2 years</span> of development and exit services to determine the <span style={{color:"#03A393"}}>prospective return on investment.</span> The analysis played a pivotal role in evaluating the viability and returns associated with the project </p>
                        </div>
                      </div>

                      <div><span className='method-stage'> Strategic Plan</span></div>

                    <div className='list-text my-3'>
                        <div className='icon'>
                        
                        </div>
                        <div className='text'>
                            <p>Developed a comprehensive plan to showcase a <span style={{color:"#03A393"}}> strategic partnership</span> between the landowner and the client. Additionally, incorporated <span style={{color:"#03A393"}}>well-defined exit strategies</span> to optimize benefits for the landowner and ensure maximum returns for the fund </p>
                        </div>
                      </div>

                      <div><span className='method-stage'> Master Developer Services</span></div>
                
                <div className='list-text last my-3'>
                    <div className='icon'>
                    
                    </div>
                    <div className='text'>
                        <p><span style={{color:"#03A393"}}></span>Highlighted the <span style={{color:"#03A393"}}> client's capabilities and expertise as a Master Developer</span> through the track record of successful past projects and skilled and experienced team</p>
                    </div>
                  </div>

                
                 
             
                      <h3 className='mt-5'>Sample Output</h3>
                    
                      <div className='sample-output1 mt-3'>
                        <img src={sm1} alt=''/>
                        <img src={sm2} alt=''/>
                        <img src={sm3} alt=''/>
                        <img src={sm4} alt=''/>
                       
                      </div>
            
                  </div>
                  
                </div>
            </Row>
          </Container>
        </section>

    
        <section className='casestudybody34-section outcome'  >
          <Container>
            <Row className='w-100 pb-5 clintrow '>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <div className="h1">Outcome</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>Developed a comprehensive Master Developer Partnership Proposal that effectively presented the client’s pitch to the landowner, resulting in their successful onboarding as the Master Developer for the fund</p>  
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={outcome} alt="" />
                </div>
            </Row>
       
          </Container>
        </section>
    
        </>  
      )
    }

export default Casestudybody34
